// src/widgets/calendarSchedule/ui/CalendarSchedule.tsx
import { FC } from 'react';
import { Calendar } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import {
  setSchedulePublicEndIntervalDate,
  setSchedulePublicStartIntervalDate,
} from 'entities/index';
import { useAppDispatch, useAppSelector } from 'shared/lib';
import styled from 'styled-components';

import { HeaderCalendar } from '../headerCalendar/ui';
import { ICalendarScheduleProps } from '../models/ICalendarScheduleProps';
import { CalendarScheduleProvider } from '../provider';

import styles from './styles.module.scss';

const StyledCalendar = styled(Calendar)`
  .ant-picker-panel {
    padding: 0px 15px 0px 15px;
  }
  .ant-picker-content th {
    font-family: 'Inter';
    color: var(--black-light-60);
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.2px;
  }

  .ant-picker-calendar-date-value {
    font-family: Inter;
    font-size: 16px;
    font-weight: 500;
  }
`;

export const CalendarSchedule: FC<ICalendarScheduleProps> = ({
  isCalendarOpen,
  setIsCalendarOpen,
}) => {
  const { startIntervalDate } = useAppSelector(
    (state) => state.schedulePublicReducer,
  );
  const dispatch = useAppDispatch();

  const onDayChange = (date: Dayjs) => {
    dispatch(setSchedulePublicStartIntervalDate(date));
    dispatch(
      setSchedulePublicEndIntervalDate(
        dayjs(date.valueOf() + 25 * 24 * 60 * 60 * 1000),
      ),
    );
  };

  return (
    <CalendarScheduleProvider>
      <div className={styles['calendar']}>
        <StyledCalendar
          defaultValue={startIntervalDate}
          value={startIntervalDate}
          onSelect={(date, { source }) => {
            if (source === 'date') {
              onDayChange(date);
              setIsCalendarOpen(isCalendarOpen);
            }
          }}
          fullscreen={false}
          headerRender={() => (
            <HeaderCalendar value={startIntervalDate} onChange={onDayChange} />
          )}
        />
      </div>
    </CalendarScheduleProvider>
  );
};
